import store from '@/store';
import { ACTION } from '../ACTION';
import { AppConfiguration, IAppConfiguration, IFreeBet } from '@/store/defaultObjects';
import { PlayersTournament } from '@/store/modules/tournament';
import { ActionContext } from 'vuex';
import { Utils } from '@/utils/Utils';
import { ICurrency } from '@/mainComponent/store/interfaces/newInterfaces/ICurrency';

type State = {
  appConfiguration: IAppConfiguration;
  otherData: {
    promoActivityList: {
      id: number;
      name: string;
      time: string;
      updateTimer: () => string;
      selectedTabIndex: number;
      isSelected: boolean;
      type: string;
      players: PlayersTournament;
      rules: any;
    }[];
    isShowingWelcomePopup: boolean;
    isShowingIcon: boolean;
    isShowIconCount: boolean;
    isProgressCheck: boolean;
    isAchievementNow: boolean;
    isTournamentNow: boolean;
    activePromoList: { type: string; status: boolean }[];
    isMenu: boolean;
    isProgress: boolean;
    isTooltip: boolean;
    idHideTooltip: any;
    isShowMenu: boolean;
    isShowTabWelcomePopup: boolean;
    messages: {
      winFreeBet: {
        isShow: boolean;
        data: {
          id: number;
        };
      };
      freeBetStarted: {
        isShow: boolean;
        data: {
          betCount: number;
        };
      };
      freeBetFinished: {
        isShow: boolean;
      };
    };
    tabIndexPopup: number;
    currencyList: ICurrency[];
  };
  idInterval: any;
  leftCanvas: number;
  topCanvas: number;
};

export default {
  state: {
    appConfiguration: AppConfiguration,
    otherData: {
      promoActivityList: [],
      isShowingWelcomePopup: false, // показываем окно с приветствием
      isShowingIcon: false, // показываем иконку,
      isShowIconCount: false, // показываем иконку с коунтером,
      isAchievementNow: false, // необходимо для того, чтоб согласовать одновременную работу ачивок и турниров
      isTournamentNow: false, // необходимо для того, чтоб согласовать одновременную работу ачивок и турниров
      activePromoList: [],
      isMenu: false,
      isProgress: false,
      isProgressCheck: false,
      isTooltip: false,
      idHideTooltip: null, // храниться айдишник setTimeout для скрытия подсказки
      isShowMenu: true,
      isShowTabWelcomePopup: false,
      messages: {
        winFreeBet: {
          isShow: false,
          data: {
            id: 0
          }
        },
        freeBetStarted: {
          isShow: false,
          data: {
            betCount: 0
          }
        },
        freeBetFinished: {
          isShow: false
        }
      },
      tabIndexPopup: 0
    },
    idInterval: null,
    leftCanvas: 0,
    topCanvas: 0
  },
  getters: {
    getUISize(state: State, getters: any) {
      if (getters.isLandscape) {
        return state.appConfiguration.uiSize.landscape;
      }

      return state.appConfiguration.uiSize.portrait;
    },
    isGameProperly(state: State, getters: any) {
      if (!getters.hasAchievement) return false;

      return state.appConfiguration.currentGid == getters.getGameId;
    },
    isLandscape(state: State) {
      return state.appConfiguration.isLandscape;
    },
    getIsMobile(state: State) {
      return state.appConfiguration.isMobile;
    },
    getAppConfiguration(state: State) {
      if (!state.appConfiguration) return {};

      return state.appConfiguration;
    },
    getPromoActivityList(state: State) {
      if (!state.otherData.promoActivityList) return [];

      return state.otherData.promoActivityList;
    },
    getIsShowingWelcomePopup(state: State) {
      return state.otherData.isShowingWelcomePopup;
    },
    getIsShowingIcon(state: State) {
      return state.otherData.isShowingIcon;
    },
    getNowAchievement(state: State) {
      return state.otherData.isAchievementNow;
    },
    getNowTournament(state: State) {
      return state.otherData.isTournamentNow;
    },
    getActivePromoList(state: State) {
      return state.otherData.activePromoList;
    },
    isProgressShow(state: State) {
      return state.otherData.isProgress;
    },
    isTooltipShow(state: State, getters: any) {
      return state.otherData.isTooltip && (getters.hasAchievement || getters.hasFreeBet || getters.hasTournament);
    },
    isShowMenu(state: State, getters: any) {
      return state.otherData.isShowingIcon && state.otherData.activePromoList.length >= 2 && state.otherData.isShowMenu;
    },
    isSoftSwiss(state: State, getters: any) {
      if (!getters.hasTournament || !state.appConfiguration.platformName) return false;

      return state.appConfiguration.platformName === 'SoftSwiss';
    },
    isMenuOpen(state: State) {
      return state.otherData.isMenu;
    },
    getUiPosition(state: State) {
      return state.appConfiguration.uiPosition;
    },
    getCanvasPosition(state: State) {
      return {
        top: state.topCanvas,
        left: state.leftCanvas
      };
    },
    isShowIconCount(state: State, getters: any) {
      return getters.hasFreeBet && state.otherData.isShowIconCount;
    },
    isShowProgressCheck(state: State, getters: any) {
      return (
        getters.hasFreeBet &&
        state.otherData.isProgressCheck &&
        (<IFreeBet>getters.getFreeBets[0]).info.distributionStatus !== 'finished'
      );
    },
    isShowTabWelcome(state: State) {
      return state.otherData.isShowTabWelcomePopup;
    },
    getFreeBetWin(state: State) {
      return state.otherData.messages.winFreeBet;
    },
    getFreeBetStarted(state: State) {
      return state.otherData.messages.freeBetStarted;
    },
    getFreeBetFinished(state: State) {
      return state.otherData.messages.freeBetFinished;
    },
    getTabIndexPopup(state: State) {
      return state.otherData.tabIndexPopup;
    },
    isNeedMoneyOnBalance(state: State, getters: any) {
      return (
        !getters.getAchievement.sendZero ||
        !getters.getAchievementTournament.sendZero ||
        !getters.getFreeRounds.sendZero
      );
    },
    getLang(state: State) {
      return state.appConfiguration.lang;
    },
  },
  mutations: {
    setAppConfiguration(state: State, data: IAppConfiguration) {
      if (data.uiSize) {
        state.appConfiguration.uiSize = data.uiSize;
      }

      state.appConfiguration.isMobile = Boolean(data.isMobile);

      if (data.lang) {
        state.appConfiguration.lang = data.lang;
        promoApp.i18n.locale = data.lang;
      }

      if (data.platformName) {
        state.appConfiguration.platformName = data.platformName;
      }

      if (data.currentGid) {
        state.appConfiguration.currentGid = data.currentGid;
      }

      if (!data.uiPosition) return;

      if (data.uiPosition?.portrait?.panel?.top) {
        // @ts-ignore
        state.appConfiguration.uiPosition.portrait.panel.top = data.uiPosition.portrait.panel.top;
      }

      if (data.uiPosition?.portrait?.menu?.top) {
        // @ts-ignore
        state.appConfiguration.uiPosition.portrait.menu.top = data.uiPosition.portrait.menu.top;
      }

      if (data.uiPosition?.landscape?.panel?.top) {
        // @ts-ignore
        state.appConfiguration.uiPosition.landscape.panel.top = data.uiPosition.landscape.panel.top;
      }

      if (data.uiPosition?.landscape?.menu?.top) {
        // @ts-ignore
        state.appConfiguration.uiPosition.landscape.menu.top = data.uiPosition.landscape.menu.top;
      }

      if (data.uiPosition?.landscape?.panel?.left) {
        // @ts-ignore
        state.appConfiguration.uiPosition.landscape.panel.left = data.uiPosition.landscape.panel.left;
      }

      if (data.uiPosition?.portrait?.panel?.left) {
        // @ts-ignore
        state.appConfiguration.uiPosition.portrait.panel.left = data.uiPosition.portrait.panel.left;
      }

      if (data.uiPosition?.portrait?.panel?.bottom) {
        // @ts-ignore
        state.appConfiguration.uiPosition.portrait.panel.bottom = data.uiPosition.portrait.panel.bottom;
      }

      if (data.uiPosition?.landscape?.panel?.right) {
        // @ts-ignore
        state.appConfiguration.uiPosition.landscape.panel.right = data.uiPosition.landscape.panel.right;
      }

      if (data.uiPosition?.portrait?.panel?.right) {
        // @ts-ignore
        state.appConfiguration.uiPosition.portrait.panel.right = data.uiPosition.portrait.panel.right;
      }

      if (data.uiPosition?.portrait?.progress?.top) {
        // @ts-ignore
        state.appConfiguration.uiPosition.portrait.progress.top = data.uiPosition.portrait.progress.top;
      }

      if (data.uiPosition?.landscape?.progress?.top) {
        // @ts-ignore
        state.appConfiguration.uiPosition.landscape.progress.top = data.uiPosition.landscape.progress.top;
      }

      if (data.uiPosition?.portrait?.progress?.bottom) {
        // @ts-ignore
        state.appConfiguration.uiPosition.portrait.progress.bottom = data.uiPosition.portrait.progress.bottom;
      }

      if (data.uiPosition?.portrait?.progress?.right) {
        // @ts-ignore
        state.appConfiguration.uiPosition.portrait.progress.right = data.uiPosition.portrait.progress.right;
      }

      if (data.uiPosition?.landscape?.progress?.right) {
        // @ts-ignore
        state.appConfiguration.uiPosition.landscape.progress.right = data.uiPosition.landscape.progress.right;
      }

      if (data.uiPosition?.landscape?.progressCheck?.left) {
        // @ts-ignore
        state.appConfiguration.uiPosition.landscape.progressCheck.left = data.uiPosition.landscape.progressCheck.left;
      }

      if (data.uiPosition?.landscape?.progressCheck?.right) {
        // @ts-ignore
        state.appConfiguration.uiPosition.landscape.progressCheck.right = data.uiPosition.landscape.progressCheck.right;
      }

      if (data.uiPosition?.landscape?.progressCheck?.top) {
        // @ts-ignore
        state.appConfiguration.uiPosition.landscape.progressCheck.top = data.uiPosition.landscape.progressCheck.top;
      }

      if (data.uiPosition?.landscape?.progressCheck?.scale) {
        // @ts-ignore
        state.appConfiguration.uiPosition.landscape.progressCheck.scale = data.uiPosition.landscape.progressCheck.scale;
      }

      if (data.uiPosition?.portrait?.progressCheck?.left) {
        // @ts-ignore
        state.appConfiguration.uiPosition.portrait.progressCheck.left = data.uiPosition.portrait.progressCheck.left;
      }

      if (data.uiPosition?.portrait?.progressCheck?.right) {
        // @ts-ignore
        state.appConfiguration.uiPosition.portrait.progressCheck.right = data.uiPosition.portrait.progressCheck.right;
      }

      if (data.uiPosition?.portrait?.progressCheck?.top) {
        // @ts-ignore
        state.appConfiguration.uiPosition.portrait.progressCheck.top = data.uiPosition.portrait.progressCheck.top;
      }

      if (data.uiPosition?.portrait?.progressCheck?.scale) {
        // @ts-ignore
        state.appConfiguration.uiPosition.portrait.progressCheck.scale = data.uiPosition.portrait.progressCheck.scale;
      }

      if (data.uiPosition?.portrait?.panelCount?.left) {
        // @ts-ignore
        state.appConfiguration.uiPosition.portrait.panelCount.left = data.uiPosition.portrait.panelCount.left;
      }

      if (data.uiPosition?.portrait?.panelCount?.right) {
        // @ts-ignore
        state.appConfiguration.uiPosition.portrait.panelCount.right = data.uiPosition.portrait.panelCount.right;
      }

      if (data.uiPosition?.portrait?.panelCount?.top) {
        // @ts-ignore
        state.appConfiguration.uiPosition.portrait.panelCount.top = data.uiPosition.portrait.panelCount.top;
      }

      if (data.uiPosition?.portrait?.panelCount?.scale) {
        // @ts-ignore
        state.appConfiguration.uiPosition.portrait.panelCount.scale = data.uiPosition.portrait.panelCount.scale;
      }

      if (data.uiPosition?.landscape?.panelCount?.left) {
        // @ts-ignore
        state.appConfiguration.uiPosition.landscape.panelCount.left = data.uiPosition.landscape.panelCount.left;
      }

      if (data.uiPosition?.landscape?.panelCount?.right) {
        // @ts-ignore
        state.appConfiguration.uiPosition.landscape.panelCount.right = data.uiPosition.landscape.panelCount.right;
      }

      if (data.uiPosition?.landscape?.panelCount?.top) {
        // @ts-ignore
        state.appConfiguration.uiPosition.landscape.panelCount.top = data.uiPosition.landscape.panelCount.top;
      }

      if (data.uiPosition?.landscape?.panelCount?.scale) {
        // @ts-ignore
        state.appConfiguration.uiPosition.landscape.panelCount.scale = data.uiPosition.landscape.panelCount.scale;
      }

      if (data.uiPosition?.mobile?.landscape?.panelCount?.top) {
        // @ts-ignore
        state.appConfiguration.uiPosition.mobile.landscape.panelCount.top =
          data.uiPosition.mobile.landscape.panelCount.top;
      }

      if (data.uiPosition?.mobile?.landscape?.progressCheck?.top) {
        // @ts-ignore
        state.appConfiguration.uiPosition.mobile.landscape.progressCheck.top =
          data.uiPosition.mobile.landscape.progressCheck.top;
      }
    },
    onResize(state: State) {
      const canvas = document.querySelector('canvas');
      if (!Utils.canvas && canvas) Utils.canvas = canvas;
      if (!Utils.canvas) return;
      store.dispatch(ACTION.SET_PIXEL_RATIO);

      changeOptions();
      setTimeout(changeOptions, 600);
      setTimeout(changeOptions, 500);
      setTimeout(changeOptions, 400);
      setTimeout(changeOptions, 200);

      function changeOptions() {
        const isCanvasOptions: boolean = store.getters.isCanvasOptions;
        const widthWrapper: number = isCanvasOptions ? Utils.canvas.width : window.innerWidth;
        const heightWrapper: number = isCanvasOptions ? Utils.canvas.height : window.innerHeight;

        state.appConfiguration.isLandscape = state.appConfiguration.isMobile ? widthWrapper > heightWrapper : true;
        state.appConfiguration.scale = Math.min(
          widthWrapper /
            store.getters.getUISize.width /
            (isCanvasOptions ? state.appConfiguration.devicePixelRatio : 1),
          heightWrapper /
            store.getters.getUISize.height /
            (isCanvasOptions ? state.appConfiguration.devicePixelRatio : 1)
        );
        state.appConfiguration.isLandscape = store.getters.isLandscape;
        state.leftCanvas = isCanvasOptions ? Number.parseFloat(Utils.canvas.style.left) || 0 : 0;
        state.topCanvas = isCanvasOptions ? Number.parseFloat(Utils.canvas.style.top) || 0 : 0;
      }
    },
    updateActivityList(state: State) {
      if (!store.getters.hasTournament) return;

      const i18n = promoApp.i18n;
      const i18nMessages = i18n.messages[i18n.locale] || i18n.messages['en'];

      const tournamentActivity = {
        id: 0,
        name: i18nMessages.tournament_title,
        time: Utils.getTimeForIcon(store.getters.hasTournament, store.getters.getTournamentFinishedTime),
        updateTimer: () => Utils.getTimeForIcon(store.getters.hasTournament, store.getters.getTournamentFinishedTime),
        selectedTabIndex: 0,
        isSelected: true,
        type: 'tournament',
        players: store.getters.getPlayersTournament,
        rules: store.getters.getRules
      };

      if (!state.otherData.promoActivityList.length) {
        state.otherData.promoActivityList = [tournamentActivity];
      } else {
        state.otherData.promoActivityList[0].name = i18nMessages.tournament_title;
        state.otherData.promoActivityList[0].players = store.getters.getPlayersTournament;
        state.otherData.promoActivityList[0].rules = store.getters.getRules;
      }
    },
    showTournamentWelcomePopup(state: State) {
      state.otherData.isShowingWelcomePopup = true;
    },
    hideTournamentWelcomePopup(state: State) {
      state.otherData.isShowingWelcomePopup = false;
    },
    showTournamentIcon(state: State) {
      state.otherData.isShowingIcon = true;
    },
    hideTournamentIcon(state: State) {
      state.otherData.isShowingIcon = false;
    },
    settingsCorrectPromo(state: State) {
      const activePromoList = [];

      if (store.getters.hasTournament) activePromoList.push({ type: 'tournament', status: false });
      if (store.getters.hasAchievement) activePromoList.push({ type: 'achievements', status: false });

      if (activePromoList.length) {
        clearTimeout(state.idInterval);
        state.idInterval = setInterval(() => {
          if (!state.otherData.isMenu && state.otherData.activePromoList.length > 1) {
            promoApp.eventEmitter.emit(ACTION.CHANGE_ICONS_PROMO);
          }
        }, 30000);

        activePromoList[0].status = true;
      }
      state.otherData.activePromoList = activePromoList;
      store.dispatch('CHANGE_ICONS_PROMO');
    },
    changeStatusMenu(state: State, status: boolean) {
      state.otherData.isMenu = status;
    },
    changeIconsPromo(state: State) {
      const list = state.otherData.activePromoList;

      if (list.length <= 0) return;

      // @ts-ignore
      const index = list.indexOf(list.find(item => item.status));
      list[index].status = false;
      const newIndex = index + 1 != list.length ? index + 1 : 0;
      list[newIndex].status = true;

      switch (list[newIndex].type) {
        case 'tournament':
          state.otherData.isTournamentNow = true;
          state.otherData.isAchievementNow = false;
          break;
        case 'achievements':
          state.otherData.isAchievementNow = true;
          state.otherData.isTournamentNow = false;
          break;
      }
    },
    showProgressBar(state: State) {
      state.otherData.isProgress = true;
    },
    hideProgressBar(state: State) {
      state.otherData.isProgress = false;
    },
    showTooltip(state: State) {
      state.otherData.isTooltip = true;
      state.otherData.idHideTooltip = setTimeout(() => {
        promoApp.store.dispatch(ACTION.HIDE_TOOLTIP);
      }, 10000);
    },
    hideTooltip(state: State) {
      state.otherData.isTooltip = false;
      clearTimeout(state.otherData.idHideTooltip);
    },
    showMenu(state: State) {
      state.otherData.isShowMenu = true;
    },
    hideMenu(state: State) {
      state.otherData.isShowMenu = false;
    },
    setPixelRation(state: State) {
      const virtualWidth: number = Utils.canvas.width;
      const realWidth: number = Utils.canvas.offsetWidth;
      state.appConfiguration.devicePixelRatio = virtualWidth / realWidth;
    },
    showTournamentIconCount(state: State) {
      state.otherData.isShowIconCount = true;
    },
    setIconCountVisible(state: State, { visible }: any) {
      state.otherData.isShowIconCount = visible;
    },
    setProgressCheck(state: State, { visible }: any) {
      state.otherData.isProgressCheck = visible;
    },
    setTabWelcomeVisible(state: State, { visible }: any) {
      state.otherData.isShowTabWelcomePopup = visible;
    },
    setMessageVisible(state: State, { visible, type = '', data }: { visible: boolean; type?: string; data?: any }) {
      switch (type) {
        case 'winFreeBet': {
          if (!visible) {
            state.otherData.messages.winFreeBet.isShow = false;
            state.otherData.messages.winFreeBet.data.id = 0;
            return;
          }
          state.otherData.messages.winFreeBet.isShow = visible;
          state.otherData.messages.winFreeBet.data.id = data.id;
          break;
        }
        case 'freeBetFinished': {
          if (!visible) {
            state.otherData.messages.freeBetFinished.isShow = false;
            return;
          }
          state.otherData.messages.freeBetFinished.isShow = visible;
          break;
        }
        case 'freeBetStarted':
          if (!visible) {
            state.otherData.messages.freeBetStarted.isShow = false;
            state.otherData.messages.freeBetStarted.data.betCount = 0;
            return;
          }
          state.otherData.messages.freeBetStarted.isShow = visible;
          state.otherData.messages.freeBetStarted.data.betCount = data.betCount;
      }
    },
    setTabIndexPopup(state: State, { position }: { position: number }) {
      state.otherData.tabIndexPopup = position;
    }
  },
  actions: {
    SET_APP_CONFIGURATION({ commit }: ActionContext<any, any>, data: IAppConfiguration) {
      if (!data) return;

      commit('setAppConfiguration', data);
      commit('onResize');
      if (data.settings) {
        commit('setSettings', data.settings);
      }
    },
    ON_RESIZE({ commit }: ActionContext<any, any>) {
      commit('onResize');
    },
    SHOW_WELCOME_POPUP({ commit }: ActionContext<any, any>) {
      commit('showTournamentWelcomePopup');
    },
    HIDE_WELCOME_POPUP({ commit }: ActionContext<any, any>) {
      commit('hideTournamentWelcomePopup');
    },
    SETTINGS_CORRECT_PROMO({ commit }: ActionContext<any, any>) {
      commit('settingsCorrectPromo');
    },
    CHANGE_ICONS_PROMO({ commit }: ActionContext<any, any>) {
      commit('changeIconsPromo');
    },
    CHANGE_STATUS_MENU({ commit }: ActionContext<any, any>, status: string) {
      commit('changeStatusMenu', status);
    },
    SHOW_PROGRESS_BAR({ commit }: ActionContext<any, any>) {
      commit('showProgressBar');
    },
    HIDE_PROGRESS_BAR({ commit }: ActionContext<any, any>) {
      commit('hideProgressBar');
    },
    SHOW_TOOLTIP({ commit }: ActionContext<any, any>) {
      commit('showTooltip');
    },
    HIDE_TOOLTIP({ commit }: ActionContext<any, any>) {
      commit('hideTooltip');
    },
    SHOW_MENU({ commit }: ActionContext<any, any>) {
      commit('showMenu');
    },
    HIDE_MENU({ commit }: ActionContext<any, any>) {
      commit('hideMenu');
    },
    SHOW_PANEL_ICON({ commit }: ActionContext<any, any>) {
      commit('showTournamentIcon');
    },
    SET_PANEL_ICON_COUNT_VISIBLE({ commit }: ActionContext<any, any>, data: any) {
      commit('setIconCountVisible', data);
    },
    SET_PROGRESS_CHECK_VISIBLE({ commit }: ActionContext<any, any>, data: any) {
      commit('setProgressCheck', data);
    },
    HIDE_PANEL_ICON({ commit }: ActionContext<any, any>) {
      commit('hideTournamentIcon');
    },
    SET_PIXEL_RATIO({ commit }: ActionContext<any, any>) {
      commit('setPixelRation');
    },
    SET_TAB_WELCOME_VISIBLE({ commit }: ActionContext<any, any>, data: any) {
      commit('setTabWelcomeVisible', data);
    },
    SET_MESSAGE_VISIBLE({ commit }: ActionContext<any, any>, data: any) {
      commit('setMessageVisible', data);
    },
    setTabIndexPopup({ commit }: ActionContext<any, any>, data: { position: number }) {
      commit('setTabIndexPopup', data);
    }
  }
};
